import React, {useEffect, useState} from 'react';
import PageWrapper from '../../../../../modules/PageWrapper';
import {useParams} from 'react-router-dom';
import {useStore} from '../../../../../../store/store';
import {observer} from 'mobx-react';
import {toast} from 'react-toastify';
import Header from './Header';
import Channels from './Cahnnels';
import Analyze from './Analyze';
import Settings from './Settings';

const otherTitle = (id) => {
  return (
    <span>
      <i className='bi bi-camera-video-fill fs-2 text-primary' style={{marginRight: '5px'}}></i>
      {`Поток #${id}`}
    </span>
  );
};
const instTitle = (id) => {
  return (
    <span>
      <i className='bi bi-instagram fs-2' style={{marginRight: '5px'}}></i>
      {`Поток #${id}`}
    </span>
  );
};
const fbTitle = (id) => {
  return (
    <span>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='19'
        height='14'
        fill='none'
        viewBox='0 0 19 14'
        style={{marginRight: '5px'}}
      >
        <path
          fill='red'
          d='M7.455 9.395V3.822l4.9 2.787-4.9 2.786Zm10.897-7.327a2.367 2.367 0 0 0-1.64-1.665L16.695.4A53.893 53.893 0 0 0 9.336.005h.037a56.302 56.302 0 0 0-7.595.421l.27-.028A2.366 2.366 0 0 0 .397 2.05l-.004.016a23.978 23.978 0 0 0-.391 4.55v-.01L0 6.764C0 8.313.143 9.83.416 11.3l-.023-.152a2.367 2.367 0 0 0 1.64 1.664l.017.004a53.884 53.884 0 0 0 7.359.394h-.037a56.299 56.299 0 0 0 7.595-.421l-.27.028a2.366 2.366 0 0 0 1.653-1.652l.004-.016a24.04 24.04 0 0 0 .392-4.385l-.001-.164v.008-.156c0-1.55-.143-3.066-.416-4.537l.023.152Z'
        />
      </svg>
      {`Поток #${id}`}
    </span>
  );
};

const Source = () => {
  const {id} = useParams();

  const [timeConfig, setTimeConfig] = useState({});
  const [prevTimeConfig, setPrevTimeConfig] = useState(null);
  const [title, setTitle] = useState(null);

  return (
    <PageWrapper
      prevTimeConfig={prevTimeConfig}
      allowAllTimes
      firstTimeConfig='current_month'
      breadcrumbs={[
        {title: 'Трекер', path: ``},
        {isSeparator: true},
        {title: 'Influence', path: ``},
        {isSeparator: true},
        {
          title: `Поток #${id}`,
          path: `/`,
        },
      ]}
      title={title ? title : `Поток #${id}`}
    >
      <Component
        id={id}
        setPrevTimeConfig={setPrevTimeConfig}
        prevTimeConfig={prevTimeConfig}
        setTitle={setTitle}
      />
    </PageWrapper>
  );
};

const Component = ({isVerify, timeConfig, setPreloader, id, setTitle}) => {
  const store = useStore();
  const [page, setPage] = useState('settings');
  const [data, setData] = useState({});

  const [link, setLink] = useState({});
  const [channel, setChannel] = useState({});
  const [bot, setBot] = useState({});

  const [statusList, setStatusList] = useState([]);
  const [typeAdvertisementList, setTypeAvertisementList] = useState(null);

  const [bayerList, setBayerList] = useState([]);

  const [saveButtonState, setSaveButtonState] = useState(0);
  const [settingData, setSettingData] = useState({});
  const [settingValidation, setSettingValidation] = useState({});

  useEffect(() => {
    isVerify && getData();
  }, [timeConfig, isVerify]);

  const getData = async () => {
    // 1. Отримуємо первинну статистику
    getInfoStats();

    const tc = timeConfig;

    // 2. Паралельне завантаження всіх потрібних даних
    const [mainStats, romiList, statusListRaw, categories, bayers] = await Promise.all([
      store.requestGet(`traffics/influence/source/${id}`, {
        params: tc,
      }),
      store.requestGet('Finance/Category/getRomiList'),
      store.requestGet(`traffics/influence/status/list`),
      store.requestGet(`traffics/influence/categories`),
      store.requestGet(`Traffics/Influence/getBayersList`),
    ]);

    if (!mainStats.traffic_category_id) {
      setTitle(otherTitle(id));
    } else if (mainStats.traffic_category_id === 1) {
      setTitle(fbTitle(id));
    } else if (settingData.traffic_category_id === 2) {
      setTitle(instTitle(id));
    }

    // 3. Витягуємо типи реклами з підкатегорій обраної категорії
    const currentCategory = categories.find((cat) => cat.id === mainStats.traffic_category_id);
    if (currentCategory) {
      const subcategories = currentCategory.subcategories || [];
      setTypeAvertisementList(
        subcategories.map((sub) => ({
          label: sub.name,
          value: sub.id,
        }))
      );
    }

    // 4. Статуси
    const statusList = statusListRaw.map((status) => ({
      label: status.name,
      value: status.id,
    }));
    setStatusList(statusList);

    // 5. Отримання трафіку (тільки якщо є traffic_id)
    const trafficInfo = mainStats.traffic_id
      ? await store.requestGet('Traffics/getInfo', {
          params: {id: mainStats?.traffic_id},
        })
      : {};

    // 6. ROMI індикатор
    const romiValue = Math.round(+mainStats.romi);
    const indicator = romiList.find(
      (item) => item.romi_min <= romiValue && romiValue <= item.romi_max
    );

    // 7. Байєри
    const bayerOptions = bayers.map((b) => ({
      value: b.id,
      label: `${b.first_name} ${b.last_name}`,
    }));
    setBayerList(bayerOptions);

    // 8. Збір загальних даних
    setData({
      ...mainStats,
      indicator,
      traffic: trafficInfo,
    });

    setSettingData({
      name: mainStats.name,
      status: mainStats.status,
      source_link: mainStats.source_link,
      cost: mainStats.cost,
      traffic_subcategory_id: mainStats.traffic_subcategory_id,
      traffic_category_id: mainStats.traffic_category_id,
      bayer_id: mainStats.bayer_id,
      bot_id: mainStats?.bot_id,
    });

    setPreloader(false);
  };

  const getInfoStats = async () => {
    const [getInfoLink, getStatuses] = await Promise.all([
      store.requestGet(`Traffics/Influence/Links/getInfo`, {
        params: {id},
      }),
      store.requestGet(`Traffics/Influence/Links/getStatuses`),
    ]);
    const getChannelInfo = !!getInfoLink.channel_id
      ? await await store.requestGet('Channels/getChannel', {
          params: {id: getInfoLink?.channel_id},
        })
      : {};

    const getBot = !!getInfoLink.bot_id
      ? await store.requestGet('Bots/getBotInfo', {
          params: {id: getInfoLink.bot_id},
        })
      : {};
    const status = getStatuses.find((el) => el.id === getInfoLink.status);

    setLink({...getInfoLink, status});
    setChannel(getChannelInfo);
    setBot(getBot);
  };

  const saveSetting = async () => {
    if (Object.values(settingValidation).some(Boolean)) return;

    const formData = new FormData();
    for (const [key, value] of Object.entries(settingData)) {
      if (key === 'avatar') {
        if (!!value.length) {
          formData.append(`${key}`, value[0]);
          continue;
        }
        continue;
      }
      if (key === 'cost') {
        formData.append(`${key}`, !value ? 0 : value.split(' ').join(''));
        continue;
      }
      formData.append(`${key}`, value || '');
    }

    const result = await store.requestPatch(
      `traffics/influence/source/${id}?token=${store?.user?.main_token}`,
      {
        data: formData,
        preloader: false,
      }
    );

    if (!!result) {
      setData((prev) => ({...prev, ...result}));
      toast.success(`Успешно обновлено!`, {});
    }

    !result &&
      toast.error(`Произошла ошибка в обновлении!`, {
        theme: 'colored',
      });
  };

  return (
    <>
      <Header
        page={page}
        setPage={setPage}
        data={data}
        id={id}
        settingData={settingData}
        setSettingData={setSettingData}
        saveSetting={saveSetting}
        saveButtonState={saveButtonState}
        setSaveButtonState={setSaveButtonState}
      />
      {page === 'settings' && (
        <Settings
          id={id}
          data={data}
          setSettingData={setSettingData}
          setSettingValidation={setSettingValidation}
          setSaveButtonState={setSaveButtonState}
          saveButtonState={saveButtonState}
          settingValidation={settingValidation}
          settingData={settingData}
          statusList={statusList}
          typeAdvertisementList={typeAdvertisementList}
          bayerList={bayerList}
          bot={bot}
        />
      )}
      {page === 'telegramChannels' && <Channels bot={bot} link={link} timeConfig={timeConfig} />}
      {page === 'analyze' && <Analyze id={id} tc={timeConfig} />}
    </>
  );
};

export default observer(Source);
